export const BASE_QUALITY_THRESHOLDS = {
  minBrightness: 40,
  maxBrightness: 240,
  maxGlareRatio: 0.18,
  minBlurVariance: 90,
  washoutMinBrightness: 160,
  washoutMaxContrastStdDev: 50,
  washoutMaxAvgSaturation: 0.12,
  minOccupancyRatio: 0.20,
  maxOccupancyRatio: 0.99,
  maxCenterOffsetRatio: 0.35,
  edgeMarginRatio: 0.015,
  minContrastStdDev: 24
};

export const QUALITY_WARNING_MARGIN = {
  brightness: 8,
  blurVariance: 18,
  occupancyRatio: 0.05,
  centerOffsetRatio: 0.05,
  contrastStdDev: 5
};

export const QUALITY_FEEDBACK = {
  blur: {
    title: 'Foto borrosa',
    guidance: 'Mantén el teléfono firme y asegúrate de que la cámara enfoque bien el objetivo.'
  },
  low_light: {
    title: 'Imagen muy oscura',
    guidance: 'Busca un lugar con más luz o evita sombras fuertes sobre el vehículo.'
  },
  over_exposed: {
    title: 'Imagen sobreexpuesta',
    guidance: 'Evita reflejos directos y ajusta el ángulo para reducir brillo extremo.'
  },
  glare: {
    title: 'Reflejos excesivos',
    guidance: 'Cambia el ángulo de captura para evitar reflejos en la superficie.'
  },
  occupancy_low: {
    title: 'El auto se ve muy pequeño',
    guidance: 'Acércate más al vehículo hasta que ocupe la mayor parte del recuadro.'
  },
  occupancy_high: {
    title: 'Encuadre demasiado cerrado',
    guidance: 'Aléjate un poco para que el vehículo se vea completo.'
  },
  edge_cut: {
    title: 'El auto no se ve completo',
    guidance: 'Asegúrate de que todo el vehículo quede dentro del recuadro de guía.'
  },
  off_center: {
    title: 'Encuadre descentrado',
    guidance: 'Centra el objetivo en el marco antes de capturar.'
  },
  profile_pose_invalid: {
    title: 'La vista no corresponde',
    guidance: 'Toma la foto más de lado y asegúrate de que el costado completo del vehículo quede visible.'
  },
  text_unreadable: {
    title: 'Lectura no detectada',
    guidance: 'Asegúrate de que el dato sea claramente visible y sin reflejos.'
  }
};

export const CAPTURE_RULES = {
  '0': {
    requireLandscape: true,
    requireFraming: true,
    requireTextReadability: false,
    instruction: 'Captura el vehículo completo desde el frente.'
  },
  '1': {
    requireLandscape: true,
    requireFraming: true,
    requireTextReadability: false,
    instruction: 'Captura el vehículo completo desde atrás.'
  },
  '2': {
    requireLandscape: true,
    requireFraming: true,
    requireTextReadability: false,
    instruction: 'Captura el vehículo completo desde el lateral izquierdo.'
  },
  '3': {
    requireLandscape: true,
    requireFraming: true,
    requireTextReadability: false,
    instruction: 'Captura el vehículo completo desde el lateral derecho.'
  },
  '4': {
    requireLandscape: true,
    requireFraming: false,
    requireTextReadability: false,
    instruction: 'Captura la zona interna del motor con buena luz y sin sombras fuertes.'
  },
  '5': {
    requireLandscape: true,
    requireFraming: false,
    requireTextReadability: false,
    instruction: 'Encuadra el centro del volante y parte del tablero.'
  },
  '6': {
    requireLandscape: true,
    requireFraming: false,
    requireTextReadability: false,
    instruction: 'Captura el tablero completo en vista panorámica (velocímetro, luces y controles).'
  },
  '7': {
    requireLandscape: true,
    requireFraming: false,
    requireTextReadability: true,
    instruction: 'Enfoca solo el odómetro/kilometraje. Haz zoom para que los dígitos sean legibles.'
  },
  '8': {
    requireLandscape: true,
    requireFraming: false,
    requireTextReadability: false,
    instruction: 'Captura la zona del motor con enfoque y buena iluminación.'
  },
  '9': {
    requireLandscape: true,
    requireFraming: false,
    requireTextReadability: true,
    instruction: 'Captura el número de chasis claramente y sin reflejos.'
  },
  '10': {
    requireLandscape: false,
    requireFraming: false,
    requireTextReadability: true,
    instruction: 'Sube o captura el documento original completo y legible.'
  }
};

export const QUALITY_THRESHOLD_OVERRIDES = {
  '9': {
    maxBrightness: 235,
    maxGlareRatio: 0.18,
    washoutMinBrightness: 155,
    washoutMaxContrastStdDev: 45,
    washoutMaxAvgSaturation: 0.10,
    minContrastStdDev: 18,
    minBlurVariance: 80
  },
  '10': {
    maxBrightness: 245,
    maxGlareRatio: 0.2,
    washoutMinBrightness: 178,
    washoutMaxContrastStdDev: 38,
    washoutMaxAvgSaturation: 0.08,
    minContrastStdDev: 20
  }
};

export const getCaptureRule = (photoType) => {
  return CAPTURE_RULES[String(photoType)] || {
    requireLandscape: false,
    requireFraming: false,
    requireTextReadability: false,
    instruction: 'Encuadra el objetivo completo y evita desenfoque.'
  };
};

export const getQualityThresholds = (photoType) => {
  return {
    ...BASE_QUALITY_THRESHOLDS,
    ...(QUALITY_THRESHOLD_OVERRIDES[String(photoType)] || {})
  };
};

export const buildFeedbackMessage = (key) => {
  const item = QUALITY_FEEDBACK[key];
  if (!item) return 'No se pudo validar la imagen. Reintenta la captura.';
  return `${item.title}. ${item.guidance}`;
};
